module.exports = __webpack_public_path__ + "media/entities/1402-20bb65db.png";